import React, { useState, useMemo } from 'react';
import Fileuploadmodal from '../../component/modal';
import "../../component/styles/styles.scss";
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Useimagepickercontext } from '../../utils/Hooks';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import TabPanel from "./tab-panel";
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import loaderAnimation from "../../assets/lottie-file/Animation - 1710440061575.json";
import Lottie from 'lottie-react';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import { useQueryClient } from 'react-query';

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 10,
    backgroundColor: 'white',
    border: "2px solid #dedede",
    borderStyle: "dashed",
    height: "300px",
    color: '#000',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer',
    justifyContent: "center"
};

export default function ImagepickerModal() {
    const query = useQueryClient();

    const { getRootProps, getInputProps, open, setOpen, handleImages, imageLoader, storeImages, handleImageColor, handleSearchApi, setStoreImagePath, storeImagePath, dataLoader } = Useimagepickercontext();

    const handleChange = (event, newValue) => {
        setStoreImagePath((prevState) => ({
            ...prevState,
            value: newValue
        }))

    };

    const style = useMemo(() => ({
        ...baseStyle,
    }), []);

    const handleModalClose = () => {
        setOpen(false);
        setStoreImagePath((prevState) => ({
            ...prevState,
            loadSearchImageComponent: false,
            value: 0,
            searchTerm: ""
        }))
    }

    const handleUnsplashImage = () => {
        handleImages()
    }

    const handleSearchField = (event) => {
        const { value } = event.target;
        setStoreImagePath((prevState) => ({
            ...prevState,
            searchTerm: value
        }))
    }

    const handleImageSearch = () => {
        handleSearchApi(storeImagePath.searchTerm);
        setStoreImagePath((prevState) => ({
            ...prevState,
            loadSearchImageComponent: true
        }))
    }

    const handleCrossIcon = () => {
        setStoreImagePath((prevState) => ({
            ...prevState,
            showCrossIcon: false,
            loadSearchImageComponent: false,
            searchTerm: "",
            storeSearchImages: []
        }));
        handleUnsplashImage();
    }

    const handleImageRendering = (e) => {
        if (e.key === " ") {
            e.preventDefault();
            return false
        } else if (e.key === "Enter") {
            handleImageSearch();
        }
    };


    return (
        <div>
            <Fileuploadmodal open={open}>
                <Box sx={{ width: '100%', bgcolor: 'background.paper' }} className="custom-modal-styles">
                    <CloseIcon className='cross-image-styles' onClick={handleModalClose} />
                    <Tabs value={storeImagePath.value} onChange={handleChange} centered>
                        <Tab label="Upload" />
                        <Tab label="Stock" onClick={handleUnsplashImage} />
                    </Tabs>
                    <TabPanel value={storeImagePath.value} index={0} className="custom-tab-styles">
                        <div>
                            {/* Your file upload component here */}
                            <div {...getRootProps({ style })}>
                                <input {...getInputProps()} />
                                <>
                                    < UploadFileIcon sx={{ marginTop: "10px", fontSize: "35px" }} />
                                    <p className='upload-text'>Upload any photo.</p>
                                </>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value={storeImagePath.value} index={1} className="custom-tab-styles">
                        {imageLoader || dataLoader ? (
                            <div className='modal-loader'>
                                <Lottie
                                    animationData={loaderAnimation}
                                    loop
                                    autoplay />
                            </div>

                        ) : (
                            <>
                                <div className='search-wrapper'>
                                    <input type='text' placeholder='Search any image' onChange={handleSearchField} value={storeImagePath.searchTerm} onKeyDown={handleImageRendering} />
                                    {storeImagePath.showCrossIcon ? <CancelIcon className='search-icon' onClick={handleCrossIcon} /> : <SearchIcon className='search-icon' onClick={handleImageSearch} />}
                                </div>
                                <div className='unsplash-image-wrapper'>
                                    <Grid container spacing={2}>
                                        {storeImagePath.loadSearchImageComponent ? (
                                            storeImagePath.storeSearchImages.length === 0 ? <p className='text-error'>No images found.</p> : (
                                                storeImagePath.storeSearchImages && storeImagePath.storeSearchImages.map((searchImages) => {
                                                    return (
                                                        <Grid item xs={4} key={searchImages.id}> {/* Use searchImages instead of images */}
                                                            <div className='img-wrapper'>
                                                                <img src={searchImages.urls.regular} alt='' onClick={() => handleImageColor(searchImages.urls.regular, searchImages.user.links.html, searchImages.user.first_name, searchImages.links.download_location)} loading='lazy' />
                                                                <p className='photo-courtesy-text'>Photo courtesy: <a href={`${searchImages.user.links.html}?utm_source=ShadeSense&utm_medium=referral`} target='_blank' rel="noreferrer">{searchImages.user.first_name}</a> on Unsplash</p>
                                                            </div>
                                                        </Grid>
                                                    );
                                                })
                                            )
                                        ) : (
                                            storeImages && storeImages.map((images) => {
                                                return (
                                                    <Grid item xs={4} key={images.id}>
                                                        <div className='img-wrapper'>
                                                            <img src={images.urls.regular} alt='' onClick={() => handleImageColor(images.urls.regular, images.user.links.html, images.user.first_name, images.links.download_location)} loading='lazy' />
                                                            <p className='photo-courtesy-text'>Photo courtesy: <a href={`${images.user.links.html}?utm_source=ShadeSense&utm_medium=referral`} target='_blank' rel="noreferrer">{images.user.first_name}</a> on Unsplash</p>
                                                        </div>
                                                    </Grid>
                                                );
                                            })
                                        )}
                                    </Grid>

                                </div>
                            </>
                        )}
                    </TabPanel>
                </Box>
            </Fileuploadmodal>
        </div>
    )
}
